import Mind from './components/Mind';
import { Modal } from 'antd';
import { useState, useRef } from 'react';
import { CloseOutlined, ReloadOutlined } from '@ant-design/icons';
import MyIcon from '@/components/MyIcon';
const MarkMap = (props) => {
    const [isDownLoad, setIsDownLoad] = useState(false);
    const mindRef = useRef<any>(null);
    const [open, setOpen] = useState(false);
    const download = () => {
        setIsDownLoad(true);
        mindRef.current?.download();
    };
    const afterDownload = () => {
        setIsDownLoad(false);
    };
    return (
        <>
            <Modal
                afterOpenChange={() => {
                    mindRef.current?.refMm?.current?.fit();
                }}
                wrapClassName="mind-modal-wrap"
                style={{
                    top: 0,
                    height: '100%',
                    paddingBottom: 0,
                    maxWidth: '100vw',
                    margin: 0
                }}
                mask={false}
                destroyOnClose={true}
                footer={null}
                closable={false}
                width={'100%'}
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => setOpen(false)}
            >
                <div className="modal-mind-box-wrap">
                    <div className="modal-mind-tool-bar">
                        <div className="title">思维导图</div>
                        <div className="action-wrap">
                            <div className="action" onClick={download}>
                                {isDownLoad ? (
                                    <ReloadOutlined spin />
                                ) : (
                                    <span className="download">
                                        <MyIcon type="icon-xiazai" />
                                    </span>
                                )}
                                下载图片
                            </div>
                            <div onClick={() => setOpen(false)} className="close">
                                <CloseOutlined />
                            </div>
                        </div>
                    </div>
                    <Mind
                        ref={mindRef}
                        {...props}
                        afterDownload={afterDownload}
                        inModal={true}
                        size={14}
                        rootClassName="modal-svg-root"
                        className="modal-svg"
                    ></Mind>
                </div>
            </Modal>
            <Mind {...props} setOpen={setOpen}></Mind>
        </>
    );
};
export default MarkMap;
